import request from '../http';

/** 分页：A/B 部门映射（sys_dept_ads_bind） */
export const listDeptAdsBinds = (params) =>
  request({ url: '/system/dept-ads-binds', method: 'get', params });

/** 分页：本系统用户与 A 用户 ID 映射（sys_user_ads_bind） */
export const listUserAdsBinds = (params) =>
  request({ url: '/system/user-ads-binds', method: 'get', params });

/** 手动新增用户映射 */
export const createUserAdsBind = (data) =>
  request({ url: '/system/user-ads-binds', method: 'post', data });

/** 删除用户映射 */
export const deleteUserAdsBind = (id) =>
  request({ url: '/system/user-ads-binds/' + id, method: 'delete' });

/** 删除部门映射（解除 A↔B 绑定） */
export const deleteDeptAdsBind = (adsDeptId) =>
  request({ url: '/system/dept-ads-binds/' + adsDeptId, method: 'delete' });

/** 获取 A 部门下的用户列表（供映射勾选） */
export const listAdsDeptUsers = (adsDeptId) =>
  request({ url: '/system/ads-dept-users', method: 'get', params: { adsDeptId } });

/** 获取 A 系统全量活跃用户（不限部门，供映射管理） */
export const listAllAdsUsers = () =>
  request({ url: '/system/ads-all-users', method: 'get' });

/** 批量设置 B 用户的 A 用户映射 */
export const batchSaveUserAdsBinds = (data) =>
  request({ url: '/system/user-ads-binds/batch', method: 'post', data });

/** 从投放系统（A）拉取部门列表（扁平，前端组装树） */
export const fetchAdsDeptTree = (config) =>
  request({ url: '/system/ads-dept-tree', method: 'get', ...config });

/** 将所选 A 部门导入为本系统部门并写入映射 */
export const importAdsDept = (data) =>
  request({ url: '/system/import-ads-dept', method: 'post', data });
